export default {
    getRideTypes: (state) => {
        return state.rideTypes
    },
}
